module.exports = __webpack_public_path__ + "static/nube_02-e017864f25687c59f1c3fd89fe618874.png";